module.exports = __webpack_public_path__ + "static/media/arco.b2eccd40.png";